// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dr-2";
export var aiChatCartContainerExit = "_dr-4";
export var aiChatContainerLarge = "_dr-0";
export var aiChatContainerSmall = "_dr-1";
export var aiChatIcon = "_dr-6";
export var slideInFromRight = "_dr-3";
export var slideOutToRight = "_dr-5";